(ns frontend.view.grid.transaction-processes-grid.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce transaction-processes (r/cursor app-db/views [:transaction-processes-grid]))
(defonce modal-state (r/cursor transaction-processes [:modals]))
(defonce grid-entities (r/cursor transaction-processes [:grid-entities]))
(defonce view-settings (r/cursor transaction-processes [:view-settings]))
(defonce filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor transaction-processes [:schema]))
